
import { DialogsWrapper } from "vue-modal-dialogs";
import { mapActions, mapGetters, mapState } from "vuex";
import { AUTH_STATE, TIME } from "~/assets/js/constants";
import AgencyPageHeader from "~/components/layout/AgencyPageHeader.vue";
import AppHeader from "~/components/layout/AppHeader.vue";
import NavTabs from "~/components/layout/NavTabs.vue";

export default {
  name: "MainLayout",
  components: {
    AppHeader,
    NavTabs,
    AgencyPageHeader,
    DialogsWrapper,
  },
  middleware: [
    "authenticated",
    async ({ store }) => {
      await store.dispatch("application/updateMainNav");
      await store.dispatch("application/setEnv");
    },
  ],
  data() {
    return {
      isSidePanelOpen: false,
    };
  },
  computed: {
    ...mapState("application", [
      "loggedUser",
      "loggedRole",
      "mainInstanceId",
      "panel",
      "downloads",
      "isWaitingForDownloads",
    ]),
    ...mapGetters({
      loggedRole: "application/getLoggedRole",
      areDownloadsCompleted: "application/areDownloadsCompleted",
      twoFAState: "authentication/getTwoFAState",
    }),
    sidePanelIcon() {
      return "mc-envelope-light";
    },
    sidePanelTitle() {
      return this.$t("techSupport.edit.formTitle");
    },
    isPreAuthCode() {
      return this.twoFAState === AUTH_STATE.ROLE_PRE_AUTH_CODE;
    },
    isPreAuthSecret() {
      return this.twoFAState === AUTH_STATE.ROLE_PRE_AUTH_SECRET;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateVersion);
  },
  mounted() {
    window.addEventListener("resize", this.updateVersion);
  },
  created() {
    this.setDownloads();
    setInterval(() => {
      if (this.isWaitingForDownloads && !this.areDownloadsCompleted) {
        this.setDownloads();
      }
    }, TIME.SECOND * 2);

    if (this.isPreAuthCode || this.isPreAuthSecret) {
      this.logout();
    }
  },
  methods: {
    ...mapActions({
      updateVersion: "application/updateVersion",
      setDownloads: "application/setDownloads",
      setFederatedView: "application/setFederatedView",
      logout: "authentication/logout",
    }),
    onPanelClose() {
      this.isSidePanelOpen = false;
    },
    onTechSupportAccept() {
      this.$refs.techSupportForm.onAccept();
    },
    onTechSupportPanelOpen() {
      this.isSidePanelOpen = true;
    },
  },
};
